/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeatureControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getSequenceOptimization(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/features/sequenceOptimization',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getRoutingWeekdayVariants(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/features/routingWeekdayVariants',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getMobileTimeRecording(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/features/mobileTimeRecording',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getCampaignSplitting(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/features/campaignSplitting',
        });
    }
}
